import { ClaimType } from '~/utils/constants';
import { checkIfPastReturnWindow } from '~/utils/order';
import { makeCrewLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData: useNewRequestLoaderData } =
  makeCrewLoader(({ context: { order, settings } }) => {
    if (order.allowClaimTypeSelection) {
      return order.allowClaimTypeSelection.params;
    }

    const canWarranty =
      settings.warranty.isEnabled &&
      order.lineItems.every(checkIfPastReturnWindow(settings.return.isEnabled));

    return redirect(
      `../${canWarranty ? ClaimType.warranty : ClaimType.return}`,
    );
  });
